import { createContext, Dispatch, ReactNode, SetStateAction, useContext, useState } from 'react';

type VideoWidgetContextType = {
  isVideoExpanded: boolean;
  setIsVideoExpanded: Dispatch<SetStateAction<boolean>>;
};

const VideoWidgetContext = createContext<VideoWidgetContextType | null>(null);

export const VideoWidgetProvider = ({ children }: { children: ReactNode }) => {
  const [isVideoExpanded, setIsVideoExpanded] = useState(false);
  return (
    <VideoWidgetContext.Provider value={{ isVideoExpanded, setIsVideoExpanded }}>
      {children}
    </VideoWidgetContext.Provider>
  );
};

export const useVideoWidget = () => {
  const ctx = useContext(VideoWidgetContext);
  if (!ctx) throw new Error('useVideoWidget must be used within VideoWidgetProvider');
  return ctx;
};
